import AuthProviderContainer from '../containers/AuthProvider/AuthProvider.container'
import UniquePassAuthContainer from '../containers/UniquePassAuth/UniquePassAuth.container'

/**
 * The UniquePassAuth's page.
 */
const UniquePassAuth = () => {
  return (
    <AuthProviderContainer>
      <UniquePassAuthContainer />
    </AuthProviderContainer>
  )
}

export default UniquePassAuth
